// Sidebar Toggle Mobile
const sidebarToggleBtnMobile = document.getElementById('sidebarToogleMobile');
const sidebarWrapper = document.getElementById('sidebarNavWrapper');

if (sidebarToggleBtnMobile) {
  sidebarToggleBtnMobile.addEventListener('click', function() {
    sidebarWrapper.classList.toggle('is-open');

    if (sidebarWrapper.classList.contains('is-open')) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'visible';
    }
  });
}

// Sidebar Toggle Desktop
const sidebarToogleBtnDesktop = document.getElementById('sidebarToogleBtnDesktop');
const mainWrapper = document.getElementById('main');
const sidebarNav = document.getElementById('sidebarNav');
const sidebarNavSubMenu = document.querySelector('.sidebar-nav-wrapper .collapse');


if (sidebarToogleBtnDesktop) {
  sidebarToogleBtnDesktop.addEventListener('click', function() {
    mainWrapper.classList.toggle('is-toggled');
  });
}

if (sidebarNav) {
  sidebarNav.addEventListener('mouseover', removeToggleClass)
  function removeToggleClass() {
    if (mainWrapper.classList.contains('is-toggled')) {
      mainWrapper.classList.remove('is-toggled');
    }
  }
}

